/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Method_Change_TitleInputs */

const vi_order_payment_method_change_title = /** @type {(inputs: Order_Payment_Method_Change_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi hình thức thanh toán`)
};

/**

* @param {Order_Payment_Method_Change_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_title = /** @type {((inputs?: Order_Payment_Method_Change_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_title(inputs)
});